/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import DropDown from './DropDown/index'
import FreeText from './FreeText/index'
import No from './No/index'
import React from 'react'
import Search from './Search/index'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let newReferralTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: newReferralTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FreeText'}>
<FreeText
  viewPath={`${viewPath}/FreeText`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DropDown'}>
<DropDown
  viewPath={`${viewPath}/DropDown`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Search'}>
<Search
  viewPath={`${viewPath}/Search`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}